module.exports = __webpack_public_path__ + "static/media/camera_off.e38dcc6f.svg";